import { useReducer, useEffect, useContext } from 'react'
import {
    Grid,
    UniversalDataTable,
    UniversalModal,
    UniversalLoadingCircle,
} from '../../../UniversalComponents'
import { getDealerProfileUsers } from '../../../../apiRoutes/dealerProfileRoutes'
import {
    standardColumnMapper,
    permissionsCheck,
    universalDateConverter,
} from '../../../../utilities/functionTools'
import { ToastMessage } from '../../../../context/ToastPopUpContext'
import { useMinimizer } from '../../../../context/MinimizeContext'
import { useAuth } from '../../../../context/AuthenticationContext'
import UserForm from '../../Users/UserAdmin/UserForm'
import { useGlobalState } from '../../../../context/GlobalStateContext'

const today = new Date().toISOString().substring(0, 10)

const DealerProfileUsers = ({ dealerProfileId }) => {
    const { globalState } = useGlobalState()
    const { oupUser } = globalState
    const { userProfile, activeManufacturer, userEmail } = oupUser
    const { userProfilePermissions } = userProfile

    const defaultState = {
        open: false,
        row: {},
        formCache: {},
        data: [],
    }

    const setToastMessage = useContext(ToastMessage)
    const reducer = (state, newState) => ({ ...state, ...newState })
    const [state, setState] = useReducer(reducer, defaultState)
    const { setMinimized } = useMinimizer()

    const { open, row, formCache, data } = state

    const defaultColumns = ['userEmail', 'userFirstName', 'userLastName']
    const visibleColumns = ['userEmail', 'userFirstName', 'userLastName']
    const customColumnNames = ['Email', 'First Name', 'Last Name']

    const getData = async () => {
        try {
            let users = await getDealerProfileUsers(dealerProfileId)

            if (users && users.length !== 0) {
                users = standardColumnMapper(defaultColumns, users)
            }

            setState({ data: users || [] })
        } catch (err: any) {
            setToastMessage(err, 'error')
            console.error(err, 'error')
        }
    }

    useEffect(() => {
        if (dealerProfileId) {
            getData()
        }
    }, [dealerProfileId])

    const setModalVisibility = async (tableRow: any, newData: any) => {
        if (tableRow?.userEmail) {
            setState({ row: tableRow, open: !open })
        } else {
            setState({ row: defaultState.row, open: !open })
        }
        getData()
    }

    const minimizeModal = () => {
        setMinimized(true, {
            title: formCache.userEmail
                ? `Edit: ${formCache.userEmail}`
                : 'Add New User',
            link: 'admin/users',
            data: formCache._id ? formCache : { ...formCache, id: 'newUser' },
            id: formCache._id ? formCache._id : 'newUser',
        })
        setState({ open: false, row: defaultState.row })
    }

    return (
        <Grid container>
            <Grid item xs={12}>
                <UniversalLoadingCircle
                    data={data}
                    reloadFunction={() => getData()}
                    customTimeoutMessage="No users assigned to this dealer profile."
                >
                    <UniversalDataTable
                        data={data}
                        visibleColumns={visibleColumns}
                        customColumnNames={customColumnNames}
                        columnWidths={{
                            userEmail: 300,
                            userFirstName: 200,
                            userLastName: 200,
                        }}
                        checkboxSelection={false}
                        getRowData={(tableRow) => {
                            setState({ open: true, row: tableRow })
                        }}
                    />
                </UniversalLoadingCircle>
            </Grid>

            <UniversalModal
                title={row.userEmail ? `User: ${row.userEmail}` : 'User'}
                timeStamp={`${
                    row?.id
                        ? ` Modified By: ${row?.updatedBy} ${
                              row?.updatedAt
                                  ? `| Modified Date ${universalDateConverter(
                                        row?.updatedAt
                                    )}`
                                  : ''
                          }  `
                        : ` Created by: ${userEmail} | Modified Date: ${today} `
                }`}
                open={open}
                onClose={(tableRow) => setModalVisibility(tableRow, undefined)}
                wrapperStyle={{
                    margin: 'auto',
                    width: '90%',
                    marginTop: 5,
                }}
            >
                <UserForm
                    row={row}
                    formDescription=""
                    onClose={(tableRow: any, newData?: any) =>
                        setModalVisibility(tableRow, newData)
                    }
                    saveCache={(data: any) => setState({ formCache: data })}
                    minimizeModal={minimizeModal}
                    userFormPermissionCheck={permissionsCheck(
                        userProfilePermissions,
                        'Users'
                    )}
                />
            </UniversalModal>
        </Grid>
    )
}

export default DealerProfileUsers
